import React, { useEffect } from "react";
import { SetFieldValue } from "react-hook-form";
import { Form } from "react-bootstrap";
import { useAuth } from "../../../../auth/context/AuthProvider";

interface PropertySelectComponentProps {
    setValue: SetFieldValue<any>;
}

const PropertySelectComponent: React.FC<PropertySelectComponentProps> = ({ setValue }) => {
    const { user } = useAuth();

    // Mengubah object properties menjadi array
    // const propertyArray = Object.entries(user?.properties || {}).map(([id, name]) => ({
    //     id,
    //     name,
    // }));

    useEffect(() => {
        if (user?.active_property_id) {
            setValue("filter.property_id", user.active_property_id);
        }
    }, [user]);

    return (
        <div>
            <Form.Label className="me-2">Current Property:</Form.Label>

            <span className="me-2 fw-bold">
                {user?.active_property}
            </span>

            {/* {propertyArray.length > 0 ? (
                <Controller
                    name="filter.property_id"
                    control={control}
                    rules={{ required: "Property selection is required" }}
                    render={({ field }) => (
                        <>
                            <Form.Select {...field} isInvalid={!!errors.property}>
                                <option value="">Select a property</option>
                                {propertyArray.map((property) => (
                                    <option key={property.id} value={property.id}>
                                        {property.name as string}
                                    </option>
                                ))}
                            </Form.Select>
                            {errors.property && (
                                <Form.Control.Feedback type="invalid">
                                    {errors.property.message as string}
                                </Form.Control.Feedback>
                            )}
                        </>
                    )}
                />
            ) : (
                <Form.Select disabled>
                    <option>No properties available</option>
                </Form.Select>
            )} */}
        </div>
    );
};

export default PropertySelectComponent;
